import { useEffect, useState } from 'react'

let priceRequest

export default function useAppStorePrice() {
  const [price, setPrice] = useState(null)
  useEffect(() => {
    let active = true
    priceRequest ??= fetch('/api/mac/app-store-price', { cache: 'no-store' })
      .then(response => response.ok ? response.json() : null)
      .then(data => data?.price || null)
      .catch(() => null)
    priceRequest.then(value => { if (active) setPrice(value) })
    return () => { active = false }
  }, [])
  return price
}
